import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Box, ListItem } from '@material-ui/core';
import TextFieldGroup from 'components/common/TextFieldGroup';
import { defaultStyles } from 'utils/Theme';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';

const BookmarkSchema = Yup.object().shape({
    title: Yup.string()
        .min(3, 'Title must be greater than 3 characters.')
        .max(50, 'Title must be less than 50 characters.')
        .required('Required'),
    description: Yup.string()
        .min(3, 'Description must be greater 3 characters.')
        .max(50, 'Description must be less than 50 characters.')
        .required('Required'),
});

const QBookmarksForm = ({ handleCreateBookmark }) => {
    const classes = defaultStyles();
    const handleSubmit = (bookmark, { resetForm }) => {
        handleCreateBookmark(bookmark);
        resetForm({ values: '' });
    };

    return (
        <Box style={{ marginBottom: 40 }}>
            <ListItem className={classes.colorPrimary}>
                Create Bookmark
            </ListItem>
            <ListItem>
                <div style={{ width: '100%' }}>
                    <Formik
                        initialValues={{ title: '', description: '' }}
                        validationSchema={BookmarkSchema}
                        onSubmit={handleSubmit}
                    >
                        {({ errors, touched, values, handleChange }) => (
                            <Form>
                                <TextFieldGroup
                                    label={'Title'}
                                    value={values.title}
                                    error={errors.title}
                                    onChange={handleChange}
                                    name={'title'}
                                />
                                <TextFieldGroup
                                    label={'Description'}
                                    error={errors.description}
                                    value={values.description}
                                    onChange={handleChange}
                                    name={'description'}
                                />
                                <div className={'o-line'}>
                                    <Button
                                        className={` ${classes.buttonPrimary}`}
                                        variant={'contained'}
                                        color={'primary'}
                                        fullWidth
                                        type="submit"
                                    >
                                        Create
                                    </Button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </ListItem>
        </Box>
    );
};

QBookmarksForm.propTypes = {
    handleCreateBookmark: PropTypes.func.isRequired,
};
export default QBookmarksForm;
